/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holding a plank for a full minute as a bodyweight core exercise.`)
};

const es_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostener una plancha durante un minuto completo como ejercicio de core con el propio peso corporal.`)
};

const de_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Unterarmstütz eine volle Minute lang halten, als Rumpfübung mit dem eigenen Körpergewicht.`)
};

const nl_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een volledige minuut een plank vasthouden als core-oefening met lichaamsgewicht.`)
};

const fr_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenir une planche pendant une minute complète comme exercice de gainage au poids du corps.`)
};

const it_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenere un plank per un minuto intero come esercizio di core a corpo libero.`)
};

const pt_br2_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segurar uma prancha por um minuto inteiro como exercício de core com o peso do corpo.`)
};

const pt_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manter uma prancha durante um minuto completo como exercício de core com o peso do corpo.`)
};

const ja_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自重コアトレーニングとして1分間フルでプランクを保持する。`)
};

const zh_timer_u1m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行一分钟完整的平板支撑，作为核心肌群自重训练。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1m_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1m_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1m_use1", locale)
	if (locale === "en") return en_timer_u1m_use1(inputs)
	if (locale === "es") return es_timer_u1m_use1(inputs)
	if (locale === "de") return de_timer_u1m_use1(inputs)
	if (locale === "nl") return nl_timer_u1m_use1(inputs)
	if (locale === "fr") return fr_timer_u1m_use1(inputs)
	if (locale === "it") return it_timer_u1m_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1m_use1(inputs)
	if (locale === "pt") return pt_timer_u1m_use1(inputs)
	if (locale === "ja") return ja_timer_u1m_use1(inputs)
	return zh_timer_u1m_use1(inputs)
};